import type {IOptionModel} from "@/models/option";

export enum OrganizationType {
    DealerHolding = 0,
    TransportCompany = 1,
    CarCompany = 2,
    Remarketing = 3,
}

export const OrganizationTypeOptions: IOptionModel<number>[] = [
    {
        label: "core.organization_type.car_company",
        value: OrganizationType.CarCompany
    },
    {
        label: "core.organization_type.transport_company",
        value: OrganizationType.TransportCompany
    },
    {
        label: "core.organization_type.remarketing",
        value: OrganizationType.Remarketing
    },
    {
        label: "core.organization_type.dealer_holding",
        value: OrganizationType.DealerHolding
    },
];
